// extracted by css-extract-rspack-plugin
export default {"inline":"ChartSettingsWidget-module__inline___kQnbe","root":"ChartSettingsWidget-module__root___oFiLy"};